import { List, ListActions } from "react-admin";
import { useSearchParams } from "react-router-dom";
import WeeklyScheduleDisciplinesFilters from "./Filters";
import WeeklyScheduleDisciplineTable from "../components/WeeklyScheduleDisciplineTable";

const ListWeeklyScheduleDisciplines = () => {
  const [searchParams] = useSearchParams();
  const weeklyScheduleId = searchParams.get("weeklyScheduleId");

  return (
    <List
      title="Седмично разписание"
      actions={<ListActions hasCreate={false} />}
      filter={{ weeklyScheduleId }}
      filters={<WeeklyScheduleDisciplinesFilters />}
      exporter={false}
      // pagination={false}
      // perPage={100}
    >
      <WeeklyScheduleDisciplineTable />
    </List>
  );
};

export default ListWeeklyScheduleDisciplines;
